import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledButton = styled(Link)`
    width: 460px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: 6px;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
    margin: ${({ theme }) => theme.spacing * 23}px 
        0 ${({ theme }) => theme.spacing * 10}px;
    @media screen and (max-width: 690px) {
        width: 100%;
        margin: ${({ theme }) => theme.spacing * 12}px 
            0 ${({ theme }) => theme.spacing * 10}px;
    }
`;

export const StyledLink = styled(Link)`
    color: rgba(3,42,85,0.87);
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    text-decoration: none;
`;

export const FlexWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: ${({ theme }) => theme.spacing * 55}px 0;
    @media screen and (max-width: 690px) {
        margin-top: ${({ theme }) => theme.spacing * 25}px;
    }
`;

export const Title = styled.h1`
    font-size: 24px;
    line-height: 36px;
    font-weight: bold;
    color: #012957;
    margin: 0;
`;

export const Description = styled.p`
    margin: ${({ theme }) => theme.spacing * 4}px 0 0;
    color: #032A55;
`;
